"use client";

import type { AgenticCaseProgressCase } from "@/components/case-checking/agenticCaseProgress";
import type { CaseAgenticMissionLink } from "@/services/api/case-checking";

import { CaseProgressBadge } from "./CaseProgressBadge";

export function CaseListProgressBadge({
  caseId,
  caseData,
  marvinStatus,
  enabled = true,
}: {
  caseId: string;
  caseData: AgenticCaseProgressCase;
  marvinStatus?: CaseAgenticMissionLink | null;
  enabled?: boolean;
}) {
  return (
    <CaseProgressBadge
      caseId={caseId}
      caseData={caseData}
      missionLink={marvinStatus}
      enabled={enabled}
      pollWhileActive={false}
      compact
      initialTaskId={marvinStatus?.runner_task_id ?? marvinStatus?.progress_task_id}
      size="sm"
      className="max-w-[5.75rem] shrink-0"
      testId={`case-agentic-status-${caseId}`}
    />
  );
}
